import {useComponentDidMount} from "@Hooks/lifecycle/useComponentDidMount";
import {useEffect} from "react";
import useUpdatePassengerGroup
    from "@CheckOrder/features/passengersList/features/passengerInfo/features/priceSelect/hooks/useUpdatePassengerGroup";
import PassengerType from "@CheckOrder/types/Passenger.type";

interface UsePassengerGroupChangedAttributes {
    passenger: PassengerType,
    passengerGroup: number,
    tripType: 'single' | 'return',
    updateBothTripSegments: boolean
    index: number,
}

export default function usePassengerGroupChanged(attributes: UsePassengerGroupChangedAttributes) {
    const {
        passenger,
        passengerGroup,
        tripType,
        updateBothTripSegments,
        index,
    } = attributes

    const isMount = useComponentDidMount()

    const {updatePassengerGroup} = useUpdatePassengerGroup({
        passenger,
        passengerGroup,
        tripType,
        updateBothTripSegments,
        passengerIndex: index,
    })

    useEffect(() => {
        if (!isMount) {
            updatePassengerGroup()
        }
    }, [passengerGroup])
}